import { render, staticRenderFns } from "./Comenzi.vue?vue&type=template&id=9216bea4&scoped=true"
import script from "./Comenzi.vue?vue&type=script&lang=js"
export * from "./Comenzi.vue?vue&type=script&lang=js"
import style0 from "./Comenzi.vue?vue&type=style&index=0&id=9216bea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9216bea4",
  null
  
)

export default component.exports